import DataLoading from "./DataLoading"
import { decorate, observable } from "mobx"
import ParametersPool from "./ParametersPool"

export class Indicator {
  constructor(jsonInd) {
    // map des props du json
    for(let key in jsonInd) {
      this[key] = jsonInd[key]
    }
  }

}

class IndicatorsPool {
  all = []
  allObj = {}

  levels = null

  values = null

  init() {
    this.all = []
    this.allObj = {}

    DataLoading.indicators.forEach(jsonInd => {
      let ind = new Indicator(jsonInd)
      this.all.push(ind)
      this.allObj[ind.id] = ind
    })
    this.levels = this.getIndicatorsLevel(this.all, window.formulas)
    this.values = this.getInitialIndicatorsValue()
  }

  getInitialIndicatorsValue() {
    let obj = {}
    this.all.forEach(ind => {
      let id = ind.id
      let paramId = ind.parameter_id

      if (paramId) {
        let val = ParametersPool.getDef(paramId)
        obj[id] = val
      } else {
        obj[id] = undefined
      }

    })
    return obj
  }

  getIndicator(id) {
    return this.allObj[id]
  }

  setIndicatorValue(id, val) {
    this.values[id] = val
  }

  getIndicatorValue(id, rounded = false) {
    let val = this.values[id]

    if(!rounded) return val

    let ind = this.getIndicator(id)
    let precision = ind === undefined ? 2 : ind.precision

    return this.roundValue(val, precision)
  }

  roundValue(val, precision) {
    if(val !== undefined) {
      let coef = Math.pow(10, precision)
      val = Math.round((val + Number.EPSILON) * coef) / coef
      val = val.toFixed(precision)
    }
    return val
  }

  get indicatorsRoundedValues() {
    const vals = {}
    this.all.forEach(i => {
      vals[i.id] = this.getIndicatorValue(i.id, true)
    })
    return vals
  }



  getIndicatorsLevel(indicators, formulas) {
    let levels = {}

    let allIndicatorsIds = indicators.map(i => i.id)
    let undefinedIndicators = new Set()

    // let count = 0
    while(Object.keys(levels).length < indicators.length) {
      // count++
      allIndicatorsIds.forEach(id => {
        // get formula
        if (levels[id] === undefined ) {
          let f = formulas[id]


          if(f === undefined || f.deps === undefined || f.deps.length === 0) {
            // si pas de dependances, cet indicateur est de level 1
            levels[id] = 1
          } else {
            // sinon, on récupère le level de ses dépendances
            // en vérifiant que la dépendance existe dans le tableau, sinon on part pour une boucle infinie
            let subLevels = f.deps.map(depId =>{
              if(allIndicatorsIds.indexOf(depId) === -1) {
                console.log("Error, cette dep n'existe pas : " + depId + " pour l'indicateur " + id)
                throw new Error("Error, cette dep n'existe pas : " + depId + " pour l'indicateur " + id)
              }

              return levels[depId]

            })
            let gotAllDependencies  = subLevels.every(subL => subL !== undefined)
            // et si on a le level de toutes ses dépendances
            if(gotAllDependencies) {
              // on set ce level-ci du level le plus élevé des dépendances + 1
              levels[id] = Math.max(...subLevels) + 1
              undefinedIndicators.delete(id)
            } else {
              undefinedIndicators.add(id)
            }
          }
        }
      })
    }
    return levels
  }


  applyTranslations() {
    if(!DataLoading.indicatorsTranslations) return

    DataLoading.indicatorsTranslations.forEach(t => {
      const ind = this.getIndicator(t.id)
      // on ecrase les contenus originels
      if(t.title) ind.title = t.title
      if(t.unit) ind.unit = t.unit
      if(t.description) ind.description = t.description
    })
  }

  applySavedValues(values) {
    for(let id in values) {
      if(this.getIndicator(id) !== undefined) {
        this.values[id] = values[id]
      }
    }
  }
}

decorate(IndicatorsPool, {
  values: observable
})


export default new IndicatorsPool()
